<!--  Header -->
<ngym-prelogin-header *ngIf="!configsStorage.isDssSuiteEnable()" [logo]="logo || '/assets/img/common/mailim-logo.png'"
  (imageClickEmitter)="navigateTo(logoNavigateUrl)" [imgWidth]="160">
  <ng-template #headerHtml>
    @if (!isBrandHeader) {
      <button class="btn btn-small btn-primary robot_header_loginLink" (click)="navigateTo('/login')">{{'SIGN_IN' |
      translate}}</button>
    }
    <app-language [theme]="'withFlag'" [isDefaultLanguages]="true" class="d-none d-md-block"></app-language>
  </ng-template>
</ngym-prelogin-header>


<!--  End of Header -->
<div id="brand-background" class="d-flex main-wrapper prelogin align-items-center">
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</div>
